import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [emailDestinataire, setEmailDestinataire] = useState('');
  const [message, setMessage] = useState('');
  const [showEnvoyerButton, setShowEnvoyerButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);  // ← AJOUTER CETTE LIGNE
  
  const isMobile = window.innerWidth <= 768;

  const generateSessionId = () => {
    const newId = Math.random().toString(36).substring(2, 8).toUpperCase();
    setSessionId(newId);
    setShowEmailInput(false);
    setEmailDestinataire('');
    setMessage('');
    setShowEnvoyerButton(true);
  };

  const envoyerEmail = async () => {
    if (!emailDestinataire) {
      setMessage('Veuillez entrer un email');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailDestinataire)) {
      setMessage('Email invalide');
      return;
    }

    setIsLoading(true);
    

    try {
      const response = await fetch('https://sosexpert-api.onrender.com/api/envoyer-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          destinataire: emailDestinataire,
          sessionId: sessionId
        })
      });

      const data = await response.json();

      if (data.succes) {
        setMessage(' Email envoyé avec succès !');
        setTimeout(() => {
          setShowEmailInput(false);
          setEmailDestinataire('');
          setMessage('');
          setIsLoading(false);
        }, 3000);
      } else {
        setMessage(' Erreur : ' + data.erreur);
        setIsLoading(false);
      }
    } catch (error) {
      setMessage(' Erreur réseau. Vérifiez que le serveur tourne.');
      setIsLoading(false);
    }
  };

  return (
    <div style={{
      height: isMobile ? 'auto' : '93dvh',
      overflow: 'hidden',
      background: '#0a192f',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: 'system-ui, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '30px',
        maxWidth: '500px',
        width: '100%',
        height: isMobile ? 'calc(100vh - 150px)' : 'calc(100vh - 100px)',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ 
            fontSize: '2.5rem', 
            margin: '0 0 10px 0',
            background: 'linear-gradient(135deg, #667eea 0%, #0a192f 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>
            🥽 SOS EXPERT
          </h1>
          <p style={{ color: '#666', margin: 0 }}>
            Assistance technique en réalité augmentée
          </p>
        </div>

        <div style={{ marginBottom: '30px' }}>
          <label style={{ 
            display: 'block', 
            marginBottom: '8px',
            fontWeight: '600',
            color: '#0a192f'
          }}>
            ID de Session
          </label>
          
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
            <input
              type="text"
              value={sessionId}
              onChange={(e) => {
                setSessionId(e.target.value.toUpperCase());
                setShowEnvoyerButton(false);
                setShowEmailInput(false);
              }}
              placeholder="Entrez un ID ou générez-en un"
              style={{
                minWidth: '0px',
                width: 'calc(100% - 100px)',
                flex: 1,
                padding: '12px 8px',
                fontSize: '1rem',
                border: '2px solid #e0e0e0',
                borderRadius: '10px',
                textAlign: 'center',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                boxSizing: 'border-box',
              }}
            />
            
            {showEnvoyerButton && sessionId && (
              <button
                onClick={() => setShowEmailInput(!showEmailInput)}
                style={{
                  flexShrink: '0',
                  padding: '12px 16px',
                  background: '#0a192f',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  cursor: 'pointer',
                  fontSize: '0.85rem',
                  fontWeight: '600',
                  maxWidth: '120px',
                  whiteSpace: 'nowrap',
                }}
              >
                Envoyer à
              </button>
            )}
          </div>

          <button
            onClick={generateSessionId}
            style={{
              marginTop: '10px',
              width: '100%',
              padding: '10px',
              background: '#f0f0f0',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              color: '#0a192f',
              fontWeight: '500'
            }}
          >
             Générer un ID aléatoire
          </button>

          {showEmailInput && sessionId && (
            <div style={{
              marginTop: '15px',
              padding: '15px',
              background: '#f8f9fa',
              borderRadius: '10px',
              border: '1px solid #ddd'
            }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#0a192f' }}>
                Email du destinataire
              </label>
              <input
                type="email"
                value={emailDestinataire}
                onChange={(e) => setEmailDestinataire(e.target.value)}
                placeholder="exemple@email.com"
                style={{
                  width: '90%',
                  padding: '12px',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  marginBottom: '10px'
                }}
              />
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={envoyerEmail}
                  disabled={isLoading}
                  style={{
                    flex: 1,
                    padding: '10px',
                    background: isLoading ? '#999' : 'linear-gradient(135deg, #667eea 0%, #0a192f 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: isLoading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {isLoading ? ' Envoi...' : ' Envoyer'}
                </button>
                <button
                  onClick={() => {
                    setShowEmailInput(false);
                    setEmailDestinataire('');
                    setMessage('');
                    setIsLoading(false);
                  }}
                  style={{
                    flex: 1,
                    padding: '10px',
                    background: '#f0f0f0',
                    color: '#0a192f',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                >
                  Annuler
                </button>
              </div>

              {/* BLOC POUR LE MESSAGE  */}
              {message && (
                <p style={{
                  marginTop: '8px',
                  padding: '8px',
                  borderRadius: '5px',
                  textAlign: 'center',
                  fontSize: '0.8rem',
                  fontWeight: '500',
                  color
                    : message === '✅ Email envoyé avec succès !'
                    ? '#2e7d32'      //  Vert
                    : '#d32f2f',      //  Rouge
                }}>
                  {message}
                </p>
              )}
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: '15px' }}>
          <button
            onClick={() => {
              if (sessionId.trim()) {
                navigate(`/operator/${sessionId}`);
              } else {
                alert('Veuillez entrer un ID de session');
              }
            }}
            style={{
              flex: 1,
              padding: '20px',
              background: '#0a192f',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
             Opérateur
            <div style={{ fontSize: '0.8rem', marginTop: '5px', opacity: 0.9 }}>
              (Terrain - Mobile)
            </div>
          </button>

          <button
            onClick={() => {
              if (sessionId.trim()) {
                navigate(`/expert/${sessionId}`);
              } else {
                alert('Veuillez entrer un ID de session');
              }
            }}
            style={{
              flex: 1,
              padding: '20px',
              background: '#1a365d',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: '1.1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
             Expert
            <div style={{ fontSize: '0.8rem', marginTop: '5px', opacity: 0.9 }}>
              (Distance - Desktop)
            </div>
          </button>
        </div>

        <div style={{ 
          marginTop: '30px',
          padding: '20px',
          background: '#f8f9fa',
          borderRadius: '10px',
          fontSize: '0.9rem',
          color: '#666'
        }}>
          <h4 style={{ margin: '0 0 10px 0', color: '#0a192f' }}> Comment ça marche ?</h4>
          <ol style={{ margin: 0, paddingLeft: '20px' }}>
            <li>Opérateur : Partagez l'ID avec l'expert</li>
            <li>Expert : Entrez le même ID pour voir le flux</li>
            <li>L'expert place des annotations AR en temps réel !</li>
          </ol>
        </div>
      </div>
    </div>
  );
}